const INIT_STATE = {
    dailyUpdateList: [],
    error: false,
    success: false,
    patientModelVisible: false,
    patientDetails: null,
    initialValue: null,
    showDailyActivityUpdateModal: false,
    showDailyActivityUpdateModalAdd: false,
    dailyQuestion: [],
    redFlags: [],
    saveDailyUpdateLoader: false,
    saveDailyUpdate: false,
    shouldDisbale: false,
    apiMessage: '',
    showSuccessMessage: false,
    showInitialValue: false,
    gettingDailyUpdateSpinner : false

}
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case 'savingDailyUpdateData_START': {
            return {
                ...state,
                saveDailyUpdateLoader: true,
            }
        }
        case 'saveDailyUpdate_SUCCESS': {
            return {
                ...state,
                saveDailyUpdateLoader: false,
                showDailyActivityUpdateModalAdd: false,
                initialValue: null,
                saveDailyUpdate: true,
                apiMessage: action.payload.message,
                showSuccessMessage: action.payload.showSuccess
            }
        }
        case 'saveDailyUpdate_FAILURE': {
            return {
                ...state,
                saveDailyUpdateLoader: false,
               
            }
        }
        case 'getPatientDailyActivityQuestion_SUCCESS': {
            return {
                ...state,
                dailyQuestion: action.payload.Record ? action.payload.Record.dailyBaseLine : [],
                // dailyQuestion: action.payload.Record.dailyBaseLine,
                redFlags: action.payload.Record ? action.payload.Record.redFlags : []

            }
        }
        case 'show_daily_activity_update_modal': {
            return {
                ...state,
                showDailyActivityUpdateModal: !state.showDailyActivityUpdateModal,
                initialValue: action.payload != null ? action.payload : null,
                shouldDisbale: action.disabled,
                showInitialValue: action.showInitialValue
            }
        }
        case 'show_daily_activity_update_modal_add': {
            return {
                ...state,
                showDailyActivityUpdateModalAdd: !state.showDailyActivityUpdateModalAdd,
                showInitialValue: action.showInitialValue
            }
        }

        case 'gettingDailyUpdate_START': {
            return {
                ...state,
                error: false,
                success: false,
                gettingDailyUpdateSpinner : true

            }
        }

        case 'getDailyUpdate_SUCCESS':
            return {
                ...state,
                dailyUpdateList: action.payload.Record,
                error: false,
                success: true,
                gettingDailyUpdateSpinner : false

            }
        case 'getDailyUpdate_FAILURE':
            return {
                ...state,
                textMessage: 'could not daily update list due to some error',
                error: true,
                gettingDailyUpdateSpinner : false
            }
        case 'patientReport_Modal': {
            return {
                ...state,
                patientModelVisible: !state.patientModelVisible,
                patientDetails: action.payload ? action.payload : '',
                error: false
            }
        }

        case 'resetDailyUpdate': {
            return {
                ...state,
                error: false,
                success: false,
                saveDailyUpdate: false
            }

        }

        default:
            return state
    }
}


